import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_brainwave-v2/artifacts/hfn8b8r0_BWT-Logo-T.png";

export default function Logo({ size = 56 }) {
  return (
    <Link
      to="/"
      className="group inline-flex items-center"
      aria-label="BrainWave Technologies"
    >
      <img
        src={LOGO_URL}
        alt="BrainWave Technologies"
        draggable={false}
        style={{ height: size, width: "auto" }}
        className="object-contain transition-transform duration-500 group-hover:scale-[1.04]"
      />
    </Link>
  );
}
